export default __webpack_public_path__ + "static/soc-one_2x-bcef6e8ab886f8ab16eca39d011998dc.png";